/* eslint-disable react-hooks/exhaustive-deps */
import {
	Button,
	FormControl,
	InputLabel,
	Stack,
	TextField,
	Select,
	Box,
	MenuItem,
	Autocomplete,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import DatePattern from "../PatternModal/DatePattern";
import { useTranslation } from "react-i18next";
import { TimeZone } from "./OutboundFieldFormattingOptions/TimeZone";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import NumberFormatter from "../PatternModal/NumberFormatter";
import LabeledCheckbox from "../../TemplateProperties/TPCheckbox";
import FormattingOptionsCheckboxes from "./FormattingOptionsCheckboxes";
import AdvancedProperties from "./Advanced Properties/AdvancedProperties";
import {
	convetCaseDropDown,
	dateIntervalDropDown,
	fillCharacterDropDown,
	fromExactDropdowns,
	onErrorDropDown,
} from "../../../constants/constantList";
import { lgDocPath } from "../../../constants/languageDocPaths";
import { PatternControl } from "./PatternControl";
import { useSelector } from "react-redux";
import { customDecoding, customEncoding } from "../../../utils/utilFunctions";


const FormattingOptions = ({ node = {}, valueshandler = () => {}, showDateInterval,callerComponent = '', hideControls, showQuoteData = false, isDateMapped, hideInboundPattern = false }) => {
	const { t } = useTranslation();
	const [inboundPattern, setInboundPattern] = useState("");
	const { baseUrl, lang } = useSelector((state) => state.queryParams);
	const [pattern, setPattern] = useState("");
	const [openDatePattern, setOpenDatePattern] = useState(false);
	const [openInboundPattern, setOpenInboundPattern] = useState(false);
	const [numberPattern, setNumberPattern] = useState("");
	const [openNumberPattern, setOpenNumberPattern] = useState(false);
	const [decimalPointPrecision, setDecimalPointPrecision] = useState("");
	const [signed, setSigned] = useState(false);
	const [precision, setPrecision] = useState("");
	const [timeZone, setTimeZone] = useState("");
	const [convertCase, setConvertCase] = useState("");
	const [paddingDirection, setPaddingDirection] = useState("");
	const [fillCharacter, setFillCharacter] = useState("");
	const [length, setLength] = useState("0");
	const [roundValue, setRoundValue] = useState(false);
	const [precisionValue, setPrecisionValue] = useState('');
	const [onError, setOnError] = useState("FALSE");
	const [defaultValue, setDefaultValue] = useState('');
	const [dateInterval, setDateInterval] = useState('');
  const [outPrecision, setOutPrecision] = useState('');

	const docPath = `${baseUrl}/docs/${
		lgDocPath[lang] || "en"
	}/Workbench/dialogs/DateFormatter.html`;

	const convertCaseOptions = [...(callerComponent === "IN_VALUES" ? 
    [{ value: "SELECT", text: "SELECT" }, ...convetCaseDropDown.filter(e => e.value !== "DO_NOT_CONVERT")] 
    : convetCaseDropDown)].map((e, i) => {
		return (
			<MenuItem key={"converCase" + i} value={e?.value}>
				{t(e?.text)}
			</MenuItem>
		);
	});
	const dateIntervalOptions = dateIntervalDropDown.map((e, i) => {
		return (
			<MenuItem key={"dateInterval" + i} value={e?.value}>
				{t(e?.text)}
			</MenuItem>
		);
	});

	const paddingDirectionOptions = fromExactDropdowns.map((e, i) => {
		return (
			<MenuItem key={"paddingDirection" + i} value={e?.value}>
				{t(e?.text)}
			</MenuItem>
		);
	});

	const fillCharacterOptions = fillCharacterDropDown.map((e, i) => {
		return { value: e?.value, label: t(e?.text) };
	});

	const advancePropertiesHandler = (obj) => {
		valueshandler(null, null , obj);
	}

	const onErrorDropDownMenu = onErrorDropDown.map((e, i) => {
		return (
			<MenuItem key={"variableAction" + i} value={e.value}>
				{t(e.text)}
			</MenuItem>
		);
	});

	useEffect(() => {
		setInboundPattern(node?.INBOUND_PATTERN || '');
		setPattern(callerComponent === "TRACKING_REPORT_PROPERTIES" ? customDecoding(node?.PATTERN || '') : node?.PATTERN || '');
		setRoundValue(node?.ROUND || '');
		setPrecision(node?.PRECISION || '');
		setOutPrecision(node?.PRECISION_OUT || '');
		setSigned(node?.UNSIGNED || "FALSE");
		setTimeZone(node?.TIMEZONE || '');
		setConvertCase(node?.CONVERT_CASE || (callerComponent === "IN_VALUES" ? "SELECT" : "DO_NOT_CONVERT"));
		setPaddingDirection(node?.PADDIR || 'RIGHT')
		setLength(node?.LENGTH || '0');
		setOnError(node?.KEEP_ORIG_DATA_ON_ERROR ||  'FALSE');
		setDefaultValue(node?.VALUE || '');
		setDateInterval(node?.UNIT || 'DAY');
	}, [node?.key, node?.id]);

	useEffect(() => {
		setFillCharacter(node?.hasOwnProperty("FILLCHAR") ? node?.FILLCHAR === " " ? "SPACE" : node?.FILLCHAR : 'SPACE');
	},[node?.key, node?.id]);

	return [
    "DATE",
    "ALPHA",
    "INTEGER",
    "FLOAT",
    "ZONED_INT",
    "PACKED_INT",
    "INTEGER",
    ...(callerComponent === "IN_VALUES" ? ["BIT_FLAG"] : [])
  ].includes(node?.FIELDTYPE) ? (
    <Stack spacing={"15px"} marginTop={1}>
        {["DATE"].includes(node?.FIELDTYPE)
          && callerComponent !== "TRACKING_REPORT_PROPERTIES" && !hideInboundPattern && (
        <PatternControl
          disabled={["TODAY", "TOMORROW", "YESTERDAY"].includes(node?.MAPNAME) || isDateMapped}
          inputId="fieldDecPattern"
          inputLabel={t("LBL_INBOUND_DATE_PATTERN")}
          pattern={inboundPattern}
          setPattern={(val) => {
            setInboundPattern(val);
            valueshandler("INBOUND_PATTERN", val);
          }}
        />
      )}

      {(["DATE", "FLOAT", "INTEGER"].includes(node?.FIELDTYPE) || (["YESTERDAY", "TODAY", "TOMORROW"].includes(node?.MAPNAME) && callerComponent === "variableProperties")) &&
        callerComponent !== "VCProperties" && (
          <PatternControl
            inputId="variableDecPattern"
            inputLabel={t("LBL_PATTERN")}
            pattern={(pattern)}
            setPattern={(val) => {
              setPattern(val);
              callerComponent === "TRACKING_REPORT_PROPERTIES" ? valueshandler(null, null, { "PATTERN": customEncoding(val), INBOUND_PATTERN: val }) : valueshandler("PATTERN", val);
            }}
            noDateChooser={["FLOAT", "INTEGER"].includes(node?.FIELDTYPE)}
            roundValue={roundValue}
            setRoundValue={setRoundValue}
            precision={precisionValue}
            setPrecision={setPrecisionValue}
            bulkValuesHandler={(valuesObj) =>
              valueshandler(null, null, valuesObj)
            }
          />
        )}

      {["DATE", "FLOAT", "INTEGER"].includes(node?.FIELDTYPE) &&
        callerComponent === "VCProperties" && (
          <PatternControl
            inputId="variableDecPattern"
            inputLabel={t("LBL_PATTERN")}
            pattern={pattern}
            setPattern={(val) => {
              setPattern(val);
              valueshandler("PATTERN", val);
            }}
            noDateChooser={["FLOAT", "INTEGER"].includes(node?.FIELDTYPE)}
            roundValue={roundValue}
            setRoundValue={setRoundValue}
            precision={precisionValue}
            setPrecision={setPrecisionValue}
            bulkValuesHandler={(valuesObj) =>
              valueshandler(null, null, valuesObj)
            }
          />
        )}

			{
				showDateInterval && (
					<FormControl className='width-100' size='small'>
						<InputLabel id='convertCase'>{t("LBL_DATE_INTERVAL")}</InputLabel>
						<Select
							variant='outlined'
							size='small'
							className={"width-100"}
							value={dateInterval}
							onChange={(e) => {
								setDateInterval(e.target.value);
								valueshandler("UNIT", e.target.value)
							}}
						>
							{dateIntervalOptions}
						</Select>
					</FormControl>
				)
			}

      {["PACKED_INT", "ZONED_INT"].includes(node?.FIELDTYPE) && callerComponent !== "IN_VALUES" && (
        <FormControl className="width-100" size="small">
          <div className="flex" style={{ gap: "5px" }}>
            <TextField
              autoComplete={"off"}
              variant="outlined"
              size="small"
              label={t("LBL_DECIMAL_POINT_PRECISION")}
              className={"width-100"}
              value={pattern}
              onChange={(e) => {
                setPattern(e.target.value);
                valueshandler("PATTERN", e.target.value);
              }}
            />
            <LabeledCheckbox
              checked={signed === "FALSE"}
              handleCheck={(checked) => {
                setSigned(checked ? "FALSE" : "TRUE");
                valueshandler("UNSIGNED", checked ? "FALSE" : "TRUE");
              }}
              label={t("LBL_SIGNED")}
            />
          </div>
        </FormControl>
      )}

      {["FLOAT", "PACKED_INT", "ZONED_INT", ...(callerComponent === "IN_VALUES" ? ["INTEGER"] : [])].includes(node?.FIELDTYPE) && (
        <FormControl className="width-100" size="small">
          <TextField
            autoComplete={"off"}
            variant="outlined"
            size="small"
            label={(callerComponent === "IN_VALUES" && ["FLOAT", "INTEGER", "ZONED_INT", "PACKED_INT"].includes(node?.FIELDTYPE)) ? t("LBL_PRECISION_IN") : t("LBL_PRECISION")}
            className={"width-100"}
            value={precision}
            onChange={(e) => {
              const newValue = e.target.value
                .replaceAll(/\D/g, "")
                .slice(0, 9);
              setPrecision(newValue);
              valueshandler("PRECISION", newValue);
            }}
          />
        </FormControl>
      )}

      {
        callerComponent === "IN_VALUES" && ["INTEGER", "ZONED_INT", "PACKED_INT"].includes(node?.FIELDTYPE) && (
          <FormControl className="width-100" size="small">
            <TextField
              autoComplete={"off"}
              variant="outlined"
              size="small"
              label={t("LBL_PRECISION_OUT")}
              className={"width-100"}
              value={outPrecision}
              onChange={(e) => {
                const newValue = e.target.value
                  .replaceAll(/\D/g, "")
                  .slice(0, 9);
                setOutPrecision(newValue);
                valueshandler("PRECISION_OUT", newValue);
              }}
            />
          </FormControl>
        )
      }

      {["DATE"].includes(node?.FIELDTYPE) && (!["VCProperties", "IN_VALUES"].includes(callerComponent)) && (
        <TimeZone
          id="fieldTimezone"
          inputValue={timeZone}
          setInputValue={(val) => {
            setTimeZone(val);
            valueshandler("TIMEZONE", val);
          }}
        />
      )}

      {["ALPHA", ...(callerComponent === "IN_VALUES" ? ["ZONED_INT", "PACKED_INT"] : [])].includes(node?.FIELDTYPE) && (
        <FormControl className="width-100" size="small">
          <InputLabel id="convertCase">{t("LBL_CONVERT_CASE")}</InputLabel>
          <Select
            variant="outlined"
            size="small"
            className={"width-100"}
            value={convertCase}
            onChange={(e) => {
              setConvertCase(e.target.value);
              e?.target?.value !== "SELECT" && valueshandler("CONVERT_CASE", e.target.value);
            }}>
            {convertCaseOptions}
          </Select>
        </FormControl>
      )}

      {["ALPHA", "DATE", ...(callerComponent === "IN_VALUES" ? ["FLOAT", "INTEGER", "ZONED_INT", "PACKED_INT"] : [])].includes(node?.FIELDTYPE) && (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(2, 1fr)",
            gap: "5px",
          }}>
          <FormControl className="width-100" size="small">
            <InputLabel id="paddingDirection">
              {t("LBL_PADDING_DIRECTION")}
            </InputLabel>
            <Select
              sx={{height: '36px'}}
              variant="outlined"
              size="small"
              className={"width-100"}
              value={paddingDirection}
              onChange={(e) => {
                setPaddingDirection(e.target.value);
                valueshandler("PADDIR", e.target.value);
              }}>
              {paddingDirectionOptions}
            </Select>
          </FormControl>
          <Autocomplete
            size="small"
            variant="outlined"
            className="width-100"
            freeSolo
            options={fillCharacterOptions}
            value={fillCharacter}
            inputValue={fillCharacter}
            onChange={(event, newValue) => {
              setFillCharacter(newValue?.value || "");
              valueshandler("FILLCHAR", newValue?.value === "SPACE" ? " " : (newValue?.value || ""));
            }}
            renderInput={(params) => (
              <TextField
                autoComplete={"off"}
                {...params}
                onChange={(event) => {
                  setFillCharacter(event.target.value);
                  valueshandler("FILLCHAR", event.target.value);
                }}
                label={t("LBL_FILL_CHAR")}
              />
            )}
          />
        </div>
      )}

      {["ALPHA", "DATE", ...(callerComponent === "IN_VALUES" ? ["BIT_FLAG", "INTEGER", "ZONED_INT", "PACKED_INT"] : [])].includes(node?.FIELDTYPE) && (
        <FormControl className="width-100" size="small">
          <TextField
            autoComplete={"off"}
            variant="outlined"
            size="small"
            label={t("LBL_LENGTH")}
            className={"width-100"}
            value={length}
            onChange={(e) => {
              const { value } = e.target;
							const newValue = value.substring(0, 9).replaceAll(/\D/g, "");
              setLength(newValue);
              valueshandler("LENGTH", newValue);
            }}
          />
        </FormControl>
      )}

      {["DATE", "FLOAT", "PACKED_INT", "ZONED_INT", "INTEGER", ...(callerComponent === "IN_VALUES" ? ["BIT_FLAG"] : [])].includes(
        node?.FIELDTYPE
      ) && (
        <FormControl className="width-100" size="small">
          <InputLabel id="onError">{t("LBL_ON_ERR")}</InputLabel>
          <Select
            variant="outlined"
            size="small"
            className={"width-100"}
            value={onError}
            onChange={(e) => {
              setOnError(e.target.value);
              valueshandler("KEEP_ORIG_DATA_ON_ERROR", e.target.value);
            }}>
            {onErrorDropDownMenu}
          </Select>
        </FormControl>
      )}

      {callerComponent !== "IN_VALUES" && ["DATE", "FLOAT", "PACKED_INT", "ZONED_INT", "INTEGER"].includes(
        node?.FIELDTYPE
      ) &&
        onError === "FALSE" && (
          <FormControl className="width-100" size="small">
            <TextField
              autoComplete={"off"}
              variant="outlined"
              size="small"
              label={t("LBL_DEFAULT_VALUE")}
              className={"width-100"}
              name="PATTERN"
              value={defaultValue}
              onChange={(e) => {
                setDefaultValue(e.target.value);
                valueshandler("VALUE", e.target.value);
              }}
            />
          </FormControl>
        )}

      <FormattingOptionsCheckboxes hideControls={hideControls} node={node} valuesHandler={valueshandler} callerComponent={callerComponent} showQuoteData={showQuoteData} />

      <AdvancedProperties
        selectedNode={node}
        updatedSelectedNodeWithAdvanceProperties={advancePropertiesHandler}
      />
    </Stack>
  ) : (
    <></>
  );
};

export default FormattingOptions;
